    import {Deserializable} from "../deserializable.model";

export class SpoolDownload implements Deserializable  {
    Id!:number;
    UserId!:string;
    Client!:string;
    Email_Id!:string;
    UploadFileName!:string;
    UploadFilePath!:string;
    Comments!:string;
    Created_Date!:string;
  

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
      }
}

export class FileDownloadpath {
  Filepath! : string;
  Filename! : string;
}
